__turbopack_context__.v({
  "placeholder": "xBKUBq_placeholder",
  "section": "xBKUBq_section",
});
